export default {
	subtitle: "Payment Expired Webhooks",
  path: "payment_webhooks_expired",
	paragraph: "If you request a payment with a dynamic Pix QR code and it is not paid by the customer within the specified date, you will receive this webhook.",
	request: {
		method: "POST",
		payloads: [
		 {
			title: "Notification",
			content: { 
			"notification": {
				"type": "payment_expired",
				"transaction_id": "UUID",
				"secret": "some-secret"
				}
			 }
		  }
		]
		
	}
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/WebHook/WebhooksPaymentExpired.js